import { supportRepository } from '../repositories/support-repository';

async function sendSupportForm(body) {
    if (!body.reason) {
        throw Error('Cannot get reason');
    }

    return supportRepository.send(body);
}

export {
    sendSupportForm
};
